<template lang="pug">

  form-group-row(:form="form", :label="label", :name="name", required)
    form-input(:form="form", :name="name")

</template>

<script>

export default {
  name: 'text-input',

  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    meta: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    form: null,
  }),

  created() {
    this.form = this.$parent.$parent.form;
    if (this.$parent.$parent.user) {
      this.form[this.name] = this.meta ? this.$parent.$parent.user.meta[this.name] : this.$parent.$parent.user[this.name];
    } else {
      this.form[this.name] = '';
    }
  },
}

</script>
